import { Component } from '@angular/core';
import { MdcService } from 'src/app/shared/mdc/mdc.service';
import { PaisService } from 'src/app/shared/pais/pais.service';

@Component({
  selector: 'app-step-intro',
  templateUrl: './step-intro.component.html',
})
export class StepIntroComponent {
  constructor(public paisService: PaisService, public mdcService: MdcService) { }  
}
